<template>
    <v-dialog v-model="showDialog" max-width="700">
        <template v-slot:activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" dark color="agora">
                <font-awesome-icon :icon="icons.cog" class="fa-fw fa-lg"></font-awesome-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>{{ $t('friendZone.manageDialog.title') }}</v-card-title>
            <v-list flat subheader three-line>
                <v-subheader>{{ $t('friendZone.manageDialog.noFriends') }}</v-subheader>
                <div class="newFriendList">
                    <div class="searchFriend">
                        <v-text-field
                            v-model="searchQuery"
                            :label="$t('friendZone.manageDialog.searchLabel')"
                            prepend-inner-icon="mdi-magnify"
                            clearable
                            hide-details="auto"
                            rounded
                            outlined
                            @keyup.enter="searchFriend"
                            @click:clear="clearResults"
                        ></v-text-field>
                    </div>
                    <div v-if="showSearchResult">
                        <div v-if="searchResult" class="searchResult">
                            <FriendEntry :friend="searchResult" />
                            <v-btn rounded outlined small color="primary" @click="sendFriendRequest" class="requestBtn">{{ $t('friendZone.manageDialog.sendRequest') }}</v-btn>
                        </div>
                        <div v-else class="searchMsg">{{ $t('friendZone.manageDialog.noResult') }}</div>
                    </div>
                </div>
                <v-divider></v-divider>
                <v-subheader>{{ $t('friendZone.manageDialog.description') }}</v-subheader>
                <div class="friendList">
                    <FriendEntry v-for="(friend, index) in currentFriendList" :key="index" :friend="friend" />
                </div>
                <v-divider></v-divider>
                <div class="friendList">
                    <FriendEntry v-for="(friend, index) in pendingFriendList" :key="index" :friend="friend" />
                </div>
            </v-list>
            <v-card-actions>
                <SaveCancelButtons align="end" @saveAsked="submit" @cancelAsked="cancel"></SaveCancelButtons>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { faCog } from '@fortawesome/pro-regular-svg-icons';
import SaveCancelButtons from '../../components/controls/SaveCancelButtons.vue';
import { findUserByEmail, sendFriendshipRequest } from '../../services/SharingService';
import FriendEntry from './FriendEntry.vue';
import Friend from '../../models/Friend';

export default {
	components: { SaveCancelButtons, FriendEntry },
    data() {
        return {
            icons: {
                cog: faCog
            },
            showDialog: false,
            settings: [],
            searchQuery: undefined,
            searchResult: undefined,
            searchDone: false
        }
    },
    computed: {
        friendList() {
            return this.$store.getters.friendList;
        },
        currentFriendList() {
            return this.friendList.filter(friend => friend.status === 'approuved');
        },
        pendingFriendList() {
            return this.friendList.filter(friend => friend.status === 'pending').sort((a, b) => a.invitationDirection.localeCompare(b.invitationDirection));
        },
        showSearchResult() {
            return this.searchDone;
        }
    },
    methods: {
        submit() {
            this.showDialog = false;
        },
        cancel() {
            this.showDialog = false;
        },
        clearResults() {
            this.searchResult = undefined;
            this.searchDone = false;
        },
        searchFriend() {
            findUserByEmail({ friendEmail: this.searchQuery }).then(user => {
                if (user) {
                    this.searchResult = new Friend({ ...user });
                }
            })
            .finally(() => {
                this.searchDone = true;
            });
        },
        sendFriendRequest() {
            sendFriendshipRequest({ TargetedUserId: this.searchResult.id }).then(() => {
                const friend = new Friend({ ...this.searchResult.toJSON(), status: 'pending', invitationDirection: 'outgoing' });
                this.$store.dispatch('addFriend', { friend });
                this.searchResult = undefined;
                this.searchQuery = undefined;
            })
            .catch(error => {
                console.error('Error sending friend request :', error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.newFriendList {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    .searchFriend {
        width: 100%;
    }
    .searchResult {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        background-color: var(--v-superLightGrayBG-base);
        padding: 10px;
        ::v-deep .requestBtn {
            text-transform: none;
            letter-spacing: normal;
        }
    }
    .searchMsg {
        padding: 10px;
        font-style: italic;
        color: var(--v-error-base);
    }
}
.friendList {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
    .friend{
        padding: 10px;
        &:hover {
            background-color: var(--v-superLightGrayBG-base);
        }
    }
}
</style>